export const isValidZIPCode = (zipCode: string) => {
  const re = /^\d{5}(?:-\d{4})?$/im;
  return re.test(zipCode);
};
